exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-f51c9bc2","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/player/page/textcomponent.vue
// module id = 73
// module chunks = 0